module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/enquiry_sent-5baff6b73308504b0bebd4870eddcd5d.png";